import { KeyboardEvent } from "react";

// Enter and Space activate a <div> that carries role="button" / "radio" /
// "checkbox" (WCAG 2.1.1): the same handler as its click, with the default
// (page scroll on Space, form submit on Enter) prevented. Other keys pass.
export function activateOnKey<T extends Element = Element>(
  handler: () => void,
) {
  return (e: KeyboardEvent<T>) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    e.preventDefault();
    handler();
  };
}
